import React, { Component } from 'react'
import { Context } from '../Context'
import logo from '../../assets/rhomberg-logo.svg'
import AnimatedLogo from '../Libs/AnimatedLogo'

export default class ServicesOverview extends Component {
    static contextType = Context
    constructor(props) {
        super(props)
        this.state = {
            activeItemIndex: 9,
        }
    }
    render() {
        return (
            <div className="main background-dark">
                <h1 className="page-title page-title-absolute text-white">Leistungsübersicht</h1>
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 h-100">{this._renderItem()}</div>
                </div>
            </div>
        )
    }
    _renderItem() {
        let currentItem = this.context.state.servicesOverview[this.state.activeItemIndex]
        let type = 1
        let radius = '400px'
        let start = -0
        let elements = this.context.state.servicesOverview
        let slice = (360 * type) / elements.length - 1
        return (
            <div className="overview-container">
                {currentItem && (
                    <div className="overview-center">
                        <p className="title">{currentItem.title}</p>
                        <p className="desc">{currentItem.detail}</p>
                    </div>
                )}
                {!currentItem && (
                    <div className="overview-center no-background-color">
                        <p className="title">
                            Wir bauen <br />
                            mit dem Blick
                            <br />
                            aufs Ganze.
                        </p>
                    </div>
                )}
                {this.context.state.servicesOverview.map((item, i) => {
                    let isActiveItem = this.state.activeItemIndex === i
                    let rotate = slice * i + start
                    let rotateReverse = rotate * -1
                    const styles = {
                        transform: `rotate(${rotate}deg) translate(${radius}) rotate(${rotateReverse}deg)`,
                    }
                    return (
                        <div
                            onClick={() => {
                                this.setState({ activeItemIndex: i })
                            }}
                            style={styles}
                            className={isActiveItem ? 'overview-item background-red ' : ' overview-item'}
                        >
                            <img src={item.cover} />
                            <p className="overview-item-title">{item.title}</p>
                        </div>
                    )
                })}
            </div>
        )
    }
}
